import request from '../request'

/**
 * 简易项目申请表相关接口
 * 从 cosystem-portal 同步过来的入口，本仓暂未启用对应后端，使用前请核对 URL。
 */

export function addSimplePlan(data) {
    return request({
        url: '/project-service/cosys/design/plan/simple/add',
        method: 'POST',
        data
    })
}

export function fetchSimplePlanDetail(id) {
    return request({
        url: `/project-service/cosys/design/plan/simple/detail/${id}`,
        method: 'GET'
    })
}

export function fetchSimplePlanList(data) {
    return request({
        url: '/project-service/cosys/design/plan/simple/list',
        method: 'POST',
        data
    })
}

export function fetchSimplePlanPersonnel(params) {
    return request({
        url: '/project-service/cosys/design/plan/simple/personnel',
        method: 'GET',
        params
    })
}

export function resubmitSimplePlan(data) {
    return request({
        url: '/project-service/cosys/design/plan/simple/resubmit',
        method: 'POST',
        data
    })
}

export function upgradeSimplePlan(data) {
    return request({
        url: '/project-service/cosys/design/plan/simple/upgrade',
        method: 'POST',
        data
    })
}

export function checkUpgradeSimplePlanMajor(data) {
    return request({
        url: '/project-service/cosys/design/plan/simple/upgrade/check/major',
        method: 'POST',
        data
    })
}

export function checkUpgradeSimplePlanSubitem(data) {
    return request({
        url: '/project-service/cosys/design/plan/simple/upgrade/check/subitem',
        method: 'POST',
        data
    })
}

export function checkUpgradeSimplePlanValid(id) {
    return request({
        url: `/project-service/cosys/design/plan/simple/upgrade/check/valid/${id}`,
        method: 'POST'
    })
}

export function fetchSimplePlanDetailByVersion(phaseId, version) {
    return request({
        url: `/project-service/cosys/design/plan/simple/detail/phase/${phaseId}/version/${version}`,
        method: 'GET'
    })
}

export function fetchSimplePlanVersionInfo(phaseId) {
    return request({
        url: `/project-service/cosys/design/plan/simple/versionInfo/${phaseId}`,
        method: 'GET'
    })
}
